export function autoDetectChartType(x: any[], y: number[]) {
  if (x.length <= 5) return 'pie';
  if (x.every(v => typeof v === 'number')) return 'line';
  return 'bar';
}

export function adaptLLMChart(llmChart: any) {
  console.log('adaptLLMChart input:', llmChart);
  
  // Handle the new data structure with title, xAxis, yAxis, and data array
  if (llmChart?.title && llmChart?.data && Array.isArray(llmChart.data)) {
    // Extract x and y arrays from the data
    const x = llmChart.data.map((item: any) => item.label);
    const y = llmChart.data.map((item: any) => item.value);
    
    // Validate the extracted data
    if (x.length !== y.length) {
      console.log('x and y arrays have different lengths');
      return null;
    }
    
    // Validate that all y values are numbers
    if (!y.every((value: any) => typeof value === 'number')) {
      console.log('Not all y values are numbers');
      return null;
    }
    
    const type =
      llmChart.type && llmChart.type !== 'auto'
        ? llmChart.type
        : autoDetectChartType(x, y);

    const result = {
      type,
      title: llmChart.title,
      xAxis: llmChart.xAxis,
      yAxis: llmChart.yAxis,
      data: llmChart.data.map((item: any) => ({
        label: item.label,
        value: Number(item.value)
      }))
    };
    
    console.log('adaptLLMChart output:', result);
    return result;
  }
  
  // Fall back to the original logic for backward compatibility
  if (!llmChart?.x || !llmChart?.y) {
    console.log('Missing x or y data');
    return null;
  }
  
  if (!Array.isArray(llmChart.x) || !Array.isArray(llmChart.y)) {
    console.log('x or y is not an array');
    return null;
  }
  
  if (llmChart.x.length !== llmChart.y.length) {
    console.log('x and y arrays have different lengths');
    return null;
  }

  const type =
    llmChart.type && llmChart.type !== 'auto'
      ? llmChart.type
      : autoDetectChartType(llmChart.x, llmChart.y);

  const result = {
    type,
    title: `${llmChart.yLabel} vs ${llmChart.xLabel}`,
    xAxis: llmChart.xLabel,
    yAxis: llmChart.yLabel,
    data: llmChart.x.map((label: string, i: number) => ({
      label,
      value: Number(llmChart.y[i])
    }))
  };
  
  console.log('adaptLLMChart output:', result);
  return result;
}
